/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ports: NonNullable<unknown> }} Team_Inspectors_TextInputs */

const en_team_inspectors_text = /** @type {((inputs: Team_Inspectors_TextInputs) => LocalizedString) & { parts: (inputs: Team_Inspectors_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Team_Inspectors_TextInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Behind the office team is a network of OCIMF accredited Master Mariners and Chief Engineers who attend vessels in more than ${i?.ports} ports.`)
		}),
		{
			parts: /** @type {(inputs: Team_Inspectors_TextInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Behind the office team is a network of OCIMF accredited Master Mariners and Chief Engineers who attend vessels in " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "more than " }, { type: "text", value: String(i?.ports) }, { type: "text", value: " ports" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const zh_team_inspectors_text = /** @type {((inputs: Team_Inspectors_TextInputs) => LocalizedString) & { parts: (inputs: Team_Inspectors_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Team_Inspectors_TextInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`办公室团队身后，是一支由 OCIMF 认证船长和轮机长组成的网络，他们在超过 ${i?.ports} 个港口登轮服务。`)
		}),
		{
			parts: /** @type {(inputs: Team_Inspectors_TextInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "办公室团队身后，是一支由 OCIMF 认证船长和轮机长组成的网络，他们在" }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "超过 " }, { type: "text", value: String(i?.ports) }, { type: "text", value: " 个港口" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "登轮服务。" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Behind the office team is a network of OCIMF accredited Master Mariners and Chief Engineers who attend vessels in more than {ports} ports." |
*
* @param {Team_Inspectors_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_inspectors_text = /** @type {((inputs: Team_Inspectors_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & { parts: (inputs: Team_Inspectors_TextInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Team_Inspectors_TextInputs, { locale?: "en" | "zh" }, { link: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Team_Inspectors_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh") return zh_team_inspectors_text(inputs)
			return en_team_inspectors_text(inputs)
		}),
		{
			parts: /** @type {(inputs: Team_Inspectors_TextInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh") return /** @type {{ parts?: (inputs: Team_Inspectors_TextInputs) => import('../runtime.js').MessagePart[] }} */ (zh_team_inspectors_text).parts?.(inputs) ?? [{ type: "text", value: zh_team_inspectors_text(inputs) }]
				return /** @type {{ parts?: (inputs: Team_Inspectors_TextInputs) => import('../runtime.js').MessagePart[] }} */ (en_team_inspectors_text).parts?.(inputs) ?? [{ type: "text", value: en_team_inspectors_text(inputs) }]
			})
		}
	)
);